module.exports = __webpack_public_path__ + "img/chevron-down.3e1de4e8.svg";